// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--2ALqO","loginFormPanel":"index-module--loginFormPanel--3bSJC","badge":"index-module--badge--3Gp5o","spacing40":"index-module--spacing40--3LS60"};